import modal from '../components/Modal';

(function() {
  let AppLink = {},
    userAgent = navigator.userAgent,
    isIphone = amI('iPhone') || amI('iPod'),
    isIpad = amI('iPad'),
    isAndroid = amI('Android'),
    nickname = '',
    title = 'NC메신저를 설치해 보세요.',
    pleaseInstall = function(_nickName) {
      return 'NC메신저를 설치하면<br/>' + _nickName + '님과 1:1 대화가 가능합니다.';
    };

  function amI(device) {
    return new RegExp(device).test(userAgent);
  }

  AppLink.excute = function(url, nm) {
    nickname = nm;
    AppLink.install();

    if (isIphone || isIpad) {
      location.href = url;
    } else if (isAndroid) {
      const iframe = document.createElement('iframe');

      iframe.src = url;
      iframe.width = 0;
      iframe.height = 0;
      iframe.style.borderWidth = 0;

      document.body.appendChild(iframe);

      setTimeout(function() {
        iframe.remove();
      }, 1000);
    }

    return false;
  };

  AppLink.install = function() {
    var date = +new Date();

    setTimeout(async function() {
      if (+new Date() - date < 1500) {
        if(!isIphone && !isIpad && !isAndroid) {
          return;
        }

        const isConfirmed = await modal.openConfirm({ title, html: pleaseInstall(nickname) });
        const url = isAndroid ? 'market://details?id=com.ncsoft.android.apps.ncm' : 'https://itunes.apple.com/kr/app/ncmesinjeo/id512119346';

        if(isConfirmed) {
          location.href = url;
        }
      }
    }, 1000);
  };

  window.AppLink = AppLink;
})();
